module.exports = "<iframe ng-src=\"{{url_ida}}\" frameborder=\"0\" style=\"overflow: hidden; height: 150vh; width: 100%\"></iframe>\n";